import * as styles from './styles';
import FocusableBackButton from '@components/FocusableBackButton';

const Content = () => {
  return (
    <div css={styles.content}>
      <FocusableBackButton />
      <p css={styles.title}>진료 대상을 선택 해주세요</p>
    </div>
  );
};

export default Content;
